import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ name, value, disabled }) {
        return (
            <toggle-group name={name} value={value} disabled={disabled}>
                {this.renderOptions()}
            </toggle-group>
        );
    }

    renderOptions = () => {
        if (this.props.options) {
            if (Array.isArray(this.props.options)) {
                return this.props.options.map(option => {
                    return (
                        <label className={this.props.value == option && !this.props.disabled ? 'checked' : ''}>
                            {option}
                            <input
                                type='radio'
                                name={this.props.name}
                                disabled={this.props.disabled}
                                value={option}
                                checked={this.props.value == option}
                                onChange={this.props.onChange}
                            />
                        </label>
                    );
                });
            } else if (typeof this.props.options === 'object') {
                return Object.keys(this.props.options).map(key => {
                    return (
                        <label className={this.props.value == key && !this.props.disabled ? 'checked' : ''}>
                            {this.props.options[key]}
                            <input
                                type='radio'
                                name={this.props.name}
                                disabled={this.props.disabled}
                                value={key}
                                checked={this.props.value == key}
                                onChange={this.props.onChange}
                            />
                        </label>
                    );
                });
            }
        }

        return null;
    }
}

export default connect()(Component);